import { createPopper } from '@popperjs/core';
import { screenAtLeast } from '../functions/screen_width';

/**
 * @module Popper
 * @description Wrapper class for popperjs functionality
 */
export default class {
  popperInstance = null;

  /**
   * @param {HTMLElement} element shared parent element of the popup
   * @param {HTMLElement} trigger trigger element of the popup
   * @param {HTMLElement} popup popup element of the popup
   * @param {string?} placement placement option, defaults to 'auto'
   */
  constructor(element, trigger, popup, placement = 'auto') {
    this.element = element;
    this.popup = popup;
    this.trigger = trigger;
    this.placement = placement;

    this.onBreakpointChange = this.onBreakpointChange.bind(this);
  }

  /**
   * Toggles visibility of the popup
   */
  toggle() {
    if (this.popup.hasAttribute('data-show')) {
      this.hide();
      return false;
    }
    else {
      this.show();
      return true;
    }
  }

  /**
   * Shows the poup
   */
  show() {
    this.element.classList.add('popper--shown');
    if (screenAtLeast('medium')) {
      this.#create();
    }

    this.#addBreakpointListener();
  }

  /**
   * Hides the poup
   */
  hide() {
    this.element.classList.remove('popper--shown');

    // wait until popper is hidden before destruction
    setTimeout(() => this.destroy(), 200);

    this.#removeBreakpointListener();
  }

  // PRIVATE

  #create() {
    this.popperInstance = createPopper(this.trigger, this.popup, { placement: this.placement });
  }

  destroy() {
    if (this.popperInstance) {
      this.popperInstance.destroy();
      this.popperInstance = null;

      this.#removeBreakpointListener();
    }
  }

  #addBreakpointListener() {
    window.addEventListener('eaimms:breakpoint.change', this.onBreakpointChange, { passive: true });
  }

  #removeBreakpointListener() {
    window.removeEventListener('eaimms:breakpoint.change', this.onBreakpointChange);
  }

  onBreakpointChange({ detail: { breakpoint, previousBreakpoint } }) {
    if (breakpoint === 'small' || previousBreakpoint === 'small') {
      this.hide();
    }
  }
}
